const state = {
    refreshKey: 0,
  };
  
  const mutations = {
    SET_REFRESH_KEY: (state, refreshKey) => {
      state.refreshKey = refreshKey;
    },
    INCREMENT_REFRESH_KEY: (state) => {
      state.refreshKey++;
    },

  };
  
  const getters = {
    refreshKey: (state) => state.refreshKey,
  };
  
  const dashboard = {
    state,
    getters,
    mutations,
  };
  
  export default dashboard;
  